import { render } from "./AdditionalsBox.vue?vue&type=template&id=6c9a060a"
import script from "./AdditionalsBox.vue?vue&type=script&lang=js"
export * from "./AdditionalsBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__